import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export function futureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const currentDate = new Date();
    currentDate.setSeconds(0, 0);

    const controlDate = new Date(control.value);
    controlDate.setHours(23, 59, 0, 0);

    return controlDate < currentDate ? { pastDate: true } : null;
  };
}

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const url = control.value?.trim();
    if (!url) return null;

    const pattern = /^https:\/\/[a-zA-Z0-9.-]+\.[a-z]{2,}(\/.*)?$/i;
    return pattern.test(url) ? null : { invalidUrl: true };
  };
}

export function passwordMatchValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const form = control as FormGroup;
  const password = form.get('password')?.value;
  const confirmPasswordControl = form.get('confirmPassword');

  if (!confirmPasswordControl) return null;

  const errors = confirmPasswordControl.errors || {};
  if (password !== confirmPasswordControl.value) {
    errors['passwordMismatch'] = true;
    confirmPasswordControl.setErrors(errors);
    return { passwordMismatch: true };
  } else {
    delete errors['passwordMismatch'];
    confirmPasswordControl.setErrors(
      Object.keys(errors).length ? errors : null,
    );
    return null;
  }
}

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumeric = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    let errorKey: string | null = null;

    switch (true) {
      case !hasUpperCase:
        errorKey = 'passwordUpperCase';
        break;
      case !hasLowerCase:
        errorKey = 'passwordLowerCase';
        break;
      case !hasNumeric:
        errorKey = 'passwordNumeric';
        break;
      case !hasSpecialChar:
        errorKey = 'passwordSpecialChar';
        break;
    }

    return errorKey ? { [errorKey]: errorKey } : null;
  };
}
